var BitmapImageChannel = (function () {
    function BitmapImageChannel() {
    }
    return BitmapImageChannel;
}());
export { BitmapImageChannel };
BitmapImageChannel.ALPHA = 8;
BitmapImageChannel.BLUE = 4;
BitmapImageChannel.GREEN = 2;
BitmapImageChannel.RED = 1;



// WEBPACK FOOTER //
// ../dist/lib/image/BitmapImageChannel.js